import { Routes } from '@angular/router';
import { founderRoutes } from './modules/panel/founder-panel/founder.routes';

export const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(value => value.AuthModule) },
  { path: 'onboarding', loadChildren: () => import('./modules/onboarding/onboarding.module').then(value => value.OnboardingModule) },
  { path: 'panel', loadChildren: () => import('./modules/panel/panel.module').then(value => value.PanelModule) },
  { path: 'panel/founder', children: founderRoutes },
  { path: '**', redirectTo: '' }
];
